import { combineReducers } from "redux";
import { homeSlice } from "../modules/home/redux/HomeSlice";
import { settingSlice } from "../modules/setting/redux/SettingSlice";
import { slotSlice } from "../modules/slot/redux/SlotSlice";
import { liveCasinoSlice } from "../modules/liveCasino/redux/LiveCasinoSlice";
import { fishingSlice } from "../modules/fishing/redux/FishingSlice";
import { promotionSlice } from "../modules/promotion/redux/PromotionSlice";
import { lotterySlice } from "../modules/lottery/redux/LotterySlice";
import { appGamesSlice } from "../modules/appGames/redux/AppGamesSlice";
import { gamePlaySlice } from "../modules/gamePlay/redux/GamePlaySlice";
import { sportSlice } from "../modules/sport/redux/SportSlice";
import { downloadSlice } from "../modules/download/redux/DownloadSlice";
import { masterLayoutSlice } from "../modules/common/redux/MasterLayoutSlice";

export const rootReducer = combineReducers({
  // get from slice file
  masterLayout: masterLayoutSlice.reducer,
  home: homeSlice.reducer,
  setting: settingSlice.reducer,
  slot: slotSlice.reducer,
  liveCasino: liveCasinoSlice.reducer,
  fishing: fishingSlice.reducer,
  promotion: promotionSlice.reducer,
  lottery: lotterySlice.reducer,
  appGames: appGamesSlice.reducer,
  gamePlay: gamePlaySlice.reducer,
  sport: sportSlice.reducer,
  download: downloadSlice.reducer,
});
